// extracted by mini-css-extract-plugin
export default {"container":"TableHeaderFilters_container__far-3"};